module.exports = __webpack_public_path__ + "static/media/AMAZON_POLISH_MAJA.aa0af1ee.mp3";